/* eslint-disable react/react-in-jsx-scope */

import { SVGProps } from 'react';

const MapIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30' fill='none'>
      <g>
        <path d='M22.4486 16.6676C22.0408 17.4661 21.6357 18.1753 21.2685 18.7694C25.3256 19.622 27.659 21.2113 27.659 22.4604C27.659 24.2558 22.8431 26.7597 15 26.7597C7.15693 26.7597 2.3411 24.2558 2.3411 22.4604C2.3411 21.221 4.63665 19.6455 8.63661 18.7868C8.26742 18.1948 7.86046 17.4875 7.44961 16.6919C3.21804 17.7296 0 19.6792 0 22.4603C0 26.7733 7.72866 29.1009 15 29.1009C22.2713 29.1009 30 26.7733 30 22.4603C30 19.658 26.7297 17.6995 22.4486 16.6676Z' />
        <path d='M14.938 22.809C16.4942 22.809 22.594 14.7645 22.594 9.28775C22.594 5.46502 20.8005 0.89917 14.938 0.89917C9.07465 0.89917 7.28204 5.46502 7.28204 9.28775C7.28204 14.8255 13.4729 22.809 14.938 22.809ZM11.3877 8.4447C11.3877 6.48543 12.9805 4.89336 14.938 4.89336C16.8955 4.89336 18.4884 6.48543 18.4884 8.4447C18.4884 10.4012 16.8955 11.9941 14.938 11.9941C12.9805 11.9941 11.3877 10.4012 11.3877 8.4447Z' />
      </g>
      <defs>
        <clipPath id='clip0_2452_404'>
          <rect width='30' height='30' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
export default MapIcon;
